import { Link } from 'react-router-dom';

/**
 * SCO-69 — the "not affiliated with Scouting America" disclaimer shown site-wide, plus
 * links to the full About/Legal page and the open-source attributions (SCO-70).
 */
export function SiteFooter() {
  return (
    <footer className="site-footer">
      <span>
        DenLodge is an independent tool and is <strong>not affiliated with, endorsed by, or
        sponsored by</strong> Scouting America / the Boy Scouts of America.
      </span>
      <span className="site-footer-links">
        <Link to="/about">About &amp; legal</Link>
        <Link to="/attributions">Open-source attributions</Link>
      </span>
    </footer>
  );
}
